import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8l-4 4l4 4","key":"svg-0"}],["path",{"d":"M17 8l4 4l-4 4","key":"svg-1"}],["path",{"d":"M14 4l-4 16","key":"svg-2"}]]

const IconCode = createReactComponent('outline', 'code', 'Code', __iconNode);

export default IconCode;